import React from 'react';
import Header from './Header';
import Footer from './Footer';

const privacyText = `
Homesteadr, LLC Privacy Policy

We value your trust. This policy describes how your information is handled by Homesteadr, LLC.

1. Information Collection
To personalize your gardening experience, we collect:
- Account Data: Email, first and last name.
- Location Context: ZIP code and Hardiness Zone to determine weather patterns and planting timelines.
- Plot Specifications: Size and style settings to initialize your homestead layout.

2. Information Usage
We utilize this information to:
- Retrieve localized weather data and provide AI-assisted microclimate insights.
- Store your garden plans, marketplace listings, and messages in secure cloud database infrastructure.
- Deliver transactional notifications and service updates.

3. Security & Hosting
All user profiles, marketplace listings, and application data are hosted on secure, encrypted cloud infrastructure with industry-standard physical and electronic safeguards. We do not sell, rent, or lease your personal information to third parties.

4. Privacy Inquiries
You can contact us or request account and data deletion at any time through support@homesteadr.ai.
`;

const termsText = `
Homesteadr Terms of Service (EULA)

Welcome to Homesteadr! Please read these terms carefully before proceeding.

1. Acceptance of Terms
By creating a profile and using the Homesteadr application, you agree to comply with and be bound by this End User License Agreement (EULA).

2. Platform Purpose
Homesteadr is a digital tool and marketplace platform designed to support gardeners, growers, and community homesteaders.

3. User Conduct & Guidelines
To keep our community safe, you agree not to:
- Post, share, or upload any abusive, harmful, or illegal content.
- Use the marketplace to list items that violate local regulations or safety policies.
- Engage in deceptive, fraudulent, or malicious behavior.

4. Advice & Information Disclaimer
AI-generated growing recommendations, climate projections, weather alerts, and gardening tips are for educational and planning purposes only. Local microclimates vary, and user discretion is advised.

5. Account Suspension
We reserve the right to suspend or terminate access to the app for users who violate community safety guidelines.

6. Marketplace Transactions & Refund Policy
All transactions conducted through the Homesteadr Farmer's Market are between independent buyers and sellers. Homesteadr acts solely as a facilitating platform and is not a party to any transaction.
`;

function LegalPage({ type }) {
  const isPrivacy = type === 'privacy';
  const title = isPrivacy ? 'Privacy Policy' : 'Terms of Service';
  const content = isPrivacy ? privacyText : termsText;

  return (
    <div className="App">
      <Header />
      <main className="container" style={{ padding: '60px 20px', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
        <a href="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#2D5A27', textDecoration: 'none', fontWeight: 'bold' }}>
          ← Back to Home
        </a>
        <h1 style={{ color: '#2D5A27', marginBottom: '20px' }}>{title}</h1>
        <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6', color: '#4A5568', background: '#F7FAFC', padding: '30px', borderRadius: '12px', border: '1px solid #E2E8F0' }}>
          {content}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default LegalPage;
